import { render, staticRenderFns } from "./FeedbackFormSection.vue?vue&type=template&id=e6470910&scoped=true"
import script from "./FeedbackFormSection.vue?vue&type=script&lang=js"
export * from "./FeedbackFormSection.vue?vue&type=script&lang=js"
import style0 from "./FeedbackFormSection.vue?vue&type=style&index=0&id=e6470910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6470910",
  null
  
)

export default component.exports